(function () {
  function init() {
    var sentinel = document.getElementById('infinite-scroll-sentinel');
    if (!sentinel) return;

    var totalPages = parseInt(sentinel.dataset.totalPages, 10) || 1;
    if (totalPages <= 1) {
      sentinel.remove();
      return;
    }

    var grid = document.getElementById('product-grid');
    if (!grid) return;

    var page = 2;
    var loading = false;

    function loadNext() {
      if (loading || page > totalPages) return;
      loading = true;
      sentinel.textContent = 'Loading more products…';

      var params = new URLSearchParams(window.location.search);
      params.delete('section_id');
      params.set('page', page);
      var url = window.location.pathname + '?' + params.toString();

      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var items = doc.querySelectorAll('#product-grid > li');
          items.forEach(function (li) { grid.appendChild(li); });

          if (typeof initializeScrollAnimationTrigger === 'function') {
            initializeScrollAnimationTrigger();
          }
          if (typeof refreshWishlistButtons === 'function') refreshWishlistButtons();
          if (typeof syncAllMobileAtcBadges === 'function') syncAllMobileAtcBadges();

          page++;
          loading = false;
          sentinel.textContent = '';

          if (page > totalPages) {
            sentinel.remove();
          }
        })
        .catch(function () {
          sentinel.textContent = '';
          loading = false;
        });
    }

    // Auto-trigger: fire loadNext when user scrolls near the sentinel
    function checkScroll() {
      if (loading) return;
      var rect = sentinel.getBoundingClientRect();
      if (rect.top < window.innerHeight + 400) {
        loadNext();
      }
    }

    window.addEventListener('scroll', checkScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
